import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Home from "./scenes/home";
import TarifaSupervision from "./scenes/tafiraSupervision";
import ConsultaAvisos from "./scenes/consultas";
import Dashboard from "./scenes/dashboard";
import DatosPersonales from "./scenes/datosPersonales";

import Login from "./scenes/login";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { useSelector } from "react-redux";

function App() {
  const [theme, colorMode] = useMode();
  const isAuth = Boolean(useSelector((state) => state.token));
  const themeMode = useSelector((state) => state.themeMode);

  useEffect(() => {
    document.body.dataset.theme = themeMode;
  }, [themeMode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isAuthenticated={isAuth} />
          <main className="content">
            <Topbar isAuthenticated={isAuth} />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/home" element={isAuth ? <Home /> : <Login />} />
              <Route
                path="/dashboard"
                element={isAuth ? <Dashboard /> : <Login />}
              />
              <Route
                path="/tarifaSupervision"
                element={isAuth ? <TarifaSupervision /> : <Login />}
              />
              <Route
                path="/consultas"
                element={isAuth ? <ConsultaAvisos /> : <Login />}
              />
              <Route
                path="/datosPersonales"
                element={isAuth ? <DatosPersonales /> : <Login />}
              />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
